import logo from '../../../assets/phenom-logo.svg';
import React, { FC } from 'react';
import { MenuItem } from '@/features/layout/types/layout.types';
import HamburgerMenu from '../HamburgerMenu';
import { IoIosArrowRoundBack } from 'react-icons/io';
import ProfileConfiguration from '@/components/ProfileConfiguration/ProfileConfiguration';
import { twMerge } from 'tailwind-merge';
import { useNavigate } from 'react-router-dom';
import ROUTES from '@/routers/Routes';

interface HeaderDesktopDisplayProps {
  modeMenuOptions: MenuItem[];
  showGoBackButton?: boolean;
}
interface HeaderMobileDisplayInterface {
  Container: FC<HeaderContainerProps>;
  Logo: FC<HeaderLogoProps>;
}
const HeaderMobileDisplay: FC<HeaderDesktopDisplayProps> & HeaderMobileDisplayInterface = ({
  modeMenuOptions,
  showGoBackButton,
}) => {
  const navigate = useNavigate();

  const handleGoToLobby = () => navigate(ROUTES.LOBBY);

  const handleGoBack = () => navigate(-1);

  return (
    <HeaderContainer>
      {showGoBackButton ? (
        <IoIosArrowRoundBack size={32} className="text-lg font-bold text-ph-gray-evening" onClick={handleGoBack} />
      ) : (
        <HamburgerMenu modeMenuOptions={modeMenuOptions} />
      )}
      <HeaderLogo onClick={handleGoToLobby} />
      <ProfileConfiguration />
    </HeaderContainer>
  );
};

interface HeaderContainerProps {
  children: React.ReactNode;
  className?: string;
}
const HeaderContainer: FC<HeaderContainerProps> = ({ children, className }) => {
  return (
    <div className="bg-transparent">
      <header className={twMerge('flex h-16 max-w-full items-center justify-between px-4 py-4', className)}>
        {children}
      </header>
    </div>
  );
};
interface HeaderLogoProps {
  onClick?: () => void;
  className?: string;
}
const HeaderLogo: FC<HeaderLogoProps> = ({ onClick, className }) => {
  return (
    <div className={twMerge('my-1 w-44 hover:cursor-pointer', className)} onClick={onClick}>
      <img src={logo} alt="Phenom Poker Logo" />
    </div>
  );
};

HeaderMobileDisplay.Container = HeaderContainer;
HeaderMobileDisplay.Logo = HeaderLogo;

export default HeaderMobileDisplay;
